import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {PreHeadingComponent} from "./pre-heading.component";



@NgModule({
  declarations: [
    PreHeadingComponent
  ],
  exports: [
    PreHeadingComponent
  ],
  imports: [
    CommonModule
  ]
})
export class PreHeadingModule { }
